"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20AudioScene = void 0;
const KHAudioScene_1 = require("./KH/KHAudioScene");
class Z20AudioScene extends KHAudioScene_1.KHGenericAudioScene {
    constructor() {
        super(Z20AudioScene.NAME);
        Z20AudioScene.Shared = this;
    }
    getSfxInfo() {
        return Z20AudioScene.sfxClips();
    }
    static sfxClips() {
        return [
            {
                key: "move",
                asset: {
                    loadKey: "move",
                    url: "assets/noise_move.wav",
                }
            }, {
                key: "move_bad",
                asset: {
                    loadKey: "move_bad",
                    url: "assets/noise_error.wav",
                }
            }, {
                key: "move_pickup",
                asset: {
                    loadKey: "move_pickup",
                    url: "assets/noise_pickup.wav",
                }
            }, {
                key: "move_death",
                asset: {
                    loadKey: "move_death",
                    url: "assets/noise_lose.wav",
                }
            }, {
                key: "win",
                asset: {
                    loadKey: "win",
                    url: "assets/noise_fanfare.wav",
                }
            }, {
                key: "tick",
                asset: {
                    loadKey: "tick",
                    url: "assets/noise_tick.wav",
                }
            }, {
                key: "time_up",
                asset: {
                    loadKey: "time_up",
                    url: "assets/noise_time_up.wav",
                }
            },
        ];
    }
}
exports.Z20AudioScene = Z20AudioScene;
Z20AudioScene.NAME = "Z20AudioScene";
